/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { TSize } from 'volta/utils/style-utils';

import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';

import type { ContentValue } from '@glint/template';

const SIZES: Partial<TSize>[] = ['sm', 'md'];

interface BvToggleSignature {
  Args: {
    size?: TSize;
    toggled: boolean;
    loading?: boolean;
    disabled?: boolean;
    tooltip?: string;
    readOnly?: boolean;
    prefix?: ContentValue;
    postfix?: ContentValue;
    onToggle?: () => void;
  };
  Element: HTMLSpanElement;
}

export default class BvToggleComponent extends Component<BvToggleSignature> {
  // Services
  // ~~~~~

  // Properties
  // ~~~~~

  forId = `${guidFor(this)}-bv-toggle`;

  // Computed Properties
  // ~~~~~

  get sizeClass() {
    const { size = 'md' } = this.args;
    return (
      size &&
      SIZES.includes(`${size}`.toLowerCase() as TSize) &&
      `bv-toggle--${`${size}`.toLowerCase()}`
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvToggle: typeof BvToggleComponent;
    'bv-toggle': typeof BvToggleComponent;
  }
}
